import { takeCustomLatest } from 'state/common/common.effects'
import {
  creditNoteActions,
  setCreditNotesLoaderAction
} from 'state/new-summary/creditNote/creditNote.actions'
import {
  fetchCreditNoteEntityEffect,
  fetchCreditNoteListEffect,
  deleteCreditNoteEffect,
  settleCreditNoteEffect
} from 'state/new-summary/creditNote/creditNote.effects'

function* fetchCreditNoteListSaga() {
  yield takeCustomLatest(creditNoteActions.FETCH_CREDIT_NOTES_LIST, fetchCreditNoteListEffect)
}

function* fetchCreditNotePreviewEntitySaga() {
  yield takeCustomLatest(
    creditNoteActions.FETCH_PREVIEW_CREDIT_NOTE_ENTITY_CONTENTS,
    fetchCreditNoteEntityEffect
  )
}

function* deleteCreditNoteSaga() {
  yield takeCustomLatest(creditNoteActions.DELETE_CREDIT_NOTE, deleteCreditNoteEffect)
}

function* settleCreditNoteSaga() {
  yield takeCustomLatest(creditNoteActions.SETTLE_CREDIT_NOTE, settleCreditNoteEffect)
}

export const CreditNotesWatcher = [
  fetchCreditNoteListSaga(),
  fetchCreditNotePreviewEntitySaga(),
  deleteCreditNoteSaga(),
  settleCreditNoteSaga()
]
